<!--本页为tab标签-->
<template>
  <el-tabs
    v-model="editableTabsValue"
    type="card"
    closable
    @tab-remove="removeTab"
    @tab-click="handleClickTab($event.name)">
    <el-tab-pane
      :key="item.name"
      v-for="item in editableTabs"
      :label="item.title"
      :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'navMain',
  data () {
    return {
      editableTabsValue: 'welcome',
      openedTab: ['welcome'],
      editableTabs: [
        {title: '欢迎使用',name: 'welcome'}
      ],

      myRoute:{
        index: '我的日志',
        form_axdw: '爱心单位采集管理',
        form_gwsbbttjb: '岗位、社保补贴统计表',
        form_gwxxgxqkb: '用工信息采集管理',
        form_gyxgwaztjb: '公益性岗位安置统计表',
        form_gyxjdbfzb: '扶贫结对帮扶管理',
        form_jtbttjb: '交通补贴统计表',
        form_jyfpcjtjb: '就业扶贫车间统计表',
        form_jyfpjd: '就业扶贫基地管理',
        form_mbrwtjb: '目标任务统计表',
        form_pxbthshfbt: '培训补贴和生活费补贴',
        form_pkhxx: '一户一档信息管理',
        helpInfo:'帮扶干部扶贫管理',
        form_ycxqzcybttjb: '一次性求职创业补贴统计表',
        form_ygdxbttjb: '以工代训补贴统计表',
        form_nclwjjr: '农村劳务经纪人统计表',
        form_nclwjjrbtsb: '农村劳务经纪人补贴申报统计表',
        form_rlzyfwjg: '人力资源服务机构统计表',
        form_rlzyfwjgbtsb: '人力资源服务机构补贴申报统计表', 
        form_dlgkbb:'独立工矿报表管理', 
        // form_tyjryb: '退役军人月报管理',
        form_rlzysczytjb:'人力资源市场主要统计表',
        form_btqkztjb:'补贴情况总统计表',
        form_ncldlzyjyhcyqkb: '农村劳动力转移就业和创业情况表',
        // form_ryxxgxb: '人员信息更新管理',
        form_danweizp:'单位招聘统计表',
        form_gwcctjb:'岗位抽查统计表',
        form_rycctjb: '人员抽查统计表',
        form_czsyrytjb:'城镇失业人员统计表',
        form_jycyfwbttjb:'就业创业服务补贴统计表(导出)',
        log:'结对帮扶管理',
        log1:'信息采集管理',
        log2:'就业服务管理',
        log3:'培训服务管理',
        log4:'创业服务管理',
        log5:'维权服务管理',
        log6:'其他服务管理',
        log7: '我的日志管理',
        log_shengcha:'服务日志审计',
        form_jyfpcjjbqkzb:'就业扶贫车间基本情况汇总表',
        form_jyfpcjxnjymc:'就业扶贫车间吸纳就业名册汇总表',
        form_jyfpcjdtgl:'就业扶贫车间动态管理台帐',
        form_xnpkldljydtjgtz:'吸纳贫困劳动力就业动态监管台账',
        form_xnydbqpkndl:'吸纳易地变迁贫困劳动力就业名册',      
        Form_grxxcj:'个人信息采集管理',
        power:'权限和密码设置',
        logo:'分站设置',
        password:'密码修改',
        sysName:'系统名称',
        mapSet:'地图信息',
        fenzhan:'创建用户',
        areaedit:'地区修改',
        zhengce:'政策法规',
        renshe:'人社业务',
        movie:'远程视频',
        chart:'报表设置',
        helpInfo:'帮扶干部扶贫管理',
        selfinfo:'个人信息',
        flzx:'法律咨询',
        ajwt:'案件委托',
        layer:'律师服务列表',
        // flzxList:'法律审核',
        studyUpload:'培训上传',
        studyApply:'培训申请',
        studyExamine:'培训审核',
        studyList:'培训列表',
        peixun:'培训服务列表',
        jiaoyu:'教育服务列表',
        // form_qz:'求职服务列表',
        // form_zp:'招聘服务列表',
        flwq:'诉讼维权',
        zhaoshang:'招商服务列表',
        jiameng:'加盟服务列表',
        rongzi:'融资服务列表',
        touzi:'投资服务列表',
        zufang:'租房服务列表',
        shoufang:'售房服务列表',
        qiche:'汽车服务列表',
        // friends:'交友服务列表',
        gouwu:'电商服务列表',
        meishi:'美食服务列表',
        lvyou:'旅游服务列表',
        jiankang:'健康服务列表',
        briefIntroduction:'竞成简介',
        idea:'竞成理念',
        culture:'竞成文化',
        team:'竞成团队',
        routeLine:'竞成之路',
        contactUs:'联系我们',
        news:'竞成新闻',
        activity:'竞成活动',
        examination:'人事招考',
        archives:'人事档案',
        information:'人事信息',
        train:'人事培训',
        notice:'才市预告',
        scene:'现场招聘',
        video:'视频招聘',
        interview:'在线访谈',
        interviewNotice:'访谈预告',
        interviewRecording:'访谈录播',
        knowAll:'百事通',
        leaderEmail:'领导信箱',
        newsCenter:'新闻中心',
        userInfo:'个人信息展示',
        companyInfo:'企业信息展示',
        subsite:'站点管理',
        role:'角色管理',
        editPwd:'修改密码',
        welcome:'欢迎使用',

        getResume:'收到的简历投递',
        sendResume:'发送的简历投递',
        getInterview:'收到的面试邀请',
        sendInterview:'发出的面试邀请',
        lookInterview:'查看面试邀请',
        lookResume:'查看简历投递',
        overallArticle:'网站文章',
        setKeyWord:'设置评论敏感词',
        layerApply:'律师申请审核',

        complaint:'投诉管理',
        communication:'交流管理',
        companyApply:'企业申请审核',

        banner_rs:'人事服务轮播管理',
        banner_xw:'新闻中心轮播管理',

        qiye:'企业管理',
        hetong:'合同管理',
        fapiao:'发票管理',
        // quick_find_job:'快速求职',

        shengting_qiye:'企业信息',
        shengting_gangwei:'岗位信息',
        shengting_zhaopinhui:'招聘会信息',
        shengting_zhaopingangwei:'招聘会招聘岗位信息',

        zhan_song:'送站管理',
        zhan_jie:'接站管理',
        zhan_song_:'送站信息',
        zhan_jie_:'接站信息',

        gongzi:'工资信息',

        shebao_geren:'个人社保信息管理',
        shebao_weizhuanyi:'未转移社保管理',
        shebao_bujiaofei:'社保补缴费管理',
        shebao_jiaona:'缴纳情况管理',
        shebao_tuifei:'社保退费管理',

        rlzy_guanlian_qiye:'关联企业管理',
        rlzy_guanlian_geren:'关联个人管理',
        rlzy_dengji_hesuan:'费用核算发放登记',
        rlzy_dengji_kaipiao:'开票登记',
        rlzy_dengji_daozhang:'到账登记',

        jzgd_yonggongbeian:'劳动用工备案',
        jzgd_zaixianqiuzhu:'在线求助',
        jzgd_zaixianqiuzhuM:'在线求助管理',

        yz_wt_weituo:'委托合同',
        yz_wt_fapiao:'发票申领',
        yz_tj_tiaojie:'调解申请',
        yz_ss_baoquan:'诉讼保全',
        yz_ss_qubaohoushen:'取保候审',
        yz_ss_gongzheng:'公证鉴定',
        yz_ss_jinzhan:'诉讼进展',
        yz_ws_zhengju:'证据资料上传',
        yz_ws_caijue:'裁判文书上传',
        yz_ws_zongjie:'案件总结上传',
        yz_ws_guidang:'案件资料归档',

        report_rsyw:'人社业务报表',
        report_grxx:'个人信息报表',
        report_grnlwhfx:'个人年龄文化分析',
        report_grjyfsfx:'个人就业方式分析',
        report_grjyqtfx:'个人就业群体分析',
        report_grjyqyfx:'个人就业区域分析',
        report_dwzpxqfx:'单位招聘需求分析',
        report_gqjgtxfx:'供求结构体系分析',

        questionnaire_jionCity:'人口进城调查',

        canjiren_jynldwjycjrzkdcb:'就业年龄段未就业残疾人状况调查表',
        tuiyijunren_tyjrjyqkcjb:'退役军人就业情况采集表',
        tuiyijunren_tyjryb:'退役军人月报管理',

        yiliaofuwu_bqhf:'病人回访',
        yiliaofuwu_hjtj:'呼叫统计',
        yiliaofuwu_hjxtpz:'呼叫系统配置',
      }
    }
  },
  computed: {
    openedTab_x () { return this.$store.state.openedTab },
    changeTab_x () { return this.$store.state.activeTab }
  },
  methods: {
    //点击标签页
    handleClickTab (route) {
      console.log(route)
      this.$store.commit('changeTab', route)
      route !== this.$route.name ? this.$router.push(route) : ''
    },
    //移除标签页
    removeTab (targetName) {
      // 首页不允许被关闭（为了防止el-tabs栏中一个tab都没有）
      // if (targetName === 'index') {
      //   return false
      // }
      let tabs = this.editableTabs
      console.log(tabs)
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.$store.commit('deductTab', targetName)
      let deductIndex = this.openedTab.indexOf(targetName)
      this.openedTab.splice(deductIndex, 1)
      this.$router.push(activeName)
      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter(tab => tab.name !== targetName)
      if (this.openedTab.length === 0) {
        let loginData = JSON.parse(window.localStorage.getItem('loginData'))
        if(loginData.admin){
          this.$router.push('log7')
          this.$store.commit('addTab', 'log7')
        }else if(loginData.organization){
          this.$router.push('companyInfo')
          this.$store.commit('addTab', 'companyInfo')
        }else if(loginData.personal){
          this.$router.push('userInfo')
          this.$store.commit('addTab', 'userInfo')
        }
      }
    }
  },
  watch: {
    //vuex里面的标签页发生改变时，比如删除标签页和增加标签页，触发函数
    openedTab_x (val) {
      if (val.length > this.openedTab.length) {
        // 添加了新的tab页
        // 导致$store.state中的openedTab长度 > 标签页中的openedTab长度
        // 因此需要新增标签页
        let newTab = val[val.length - 1] // 新增的肯定在数组最后一个
        this.editableTabs.push({
          title: this.myRoute[newTab],
          name: newTab,
          content: ''
        })
        this.editableTabsValue = newTab
        console.log(this.editableTabsValue)
        this.$store.commit('changeTab', newTab)
        this.openedTab.push(newTab)
      }
    },
    changeTab_x (val) {
      // 监听activetab以实现点击左侧栏时激活已存在的标签
      if (val !== this.editableTabsValue) {
        this.editableTabsValue = val
      }
    }
  },
  
}
</script>

<style scoped>

</style>
